/* eslint-disable */

/*
 * This is a generated file created by deere-ui-svg-to-react.
 *
 * Please do not modify this file directly as it will be regenerated at build time.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

exports["default"] = _react2["default"].createClass({
    displayName: "linkBroken",

    getDefaultProps: function getDefaultProps() {
        return {
            "st0": {
                "fill": "#666766"
            },
            "linkBroken": {
                "backgroundImage": "none",
                "backgroundPosition": "0% 0%",
                "display": "inline",
                "fill": "#333"
            },
            "width": "23.8",
            "height": "23.9"
        };
    },

    render: function render() {
        return _react2["default"].createElement(
            "svg",
            { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 23.8 23.9", className: "linkBroken", width: this.props.width, height: this.props.height },
            _react2["default"].createElement("path", { className: "st0", d: "M9 6.7l5.2-5.2c1-1 2.4-1.5 3.9-1.5 1.5.1 2.8.7 3.9 1.8 2.3 2.2 2.4 5.7.3 8l-3.7 3.7V9.7l1.8-1.9c1-1 .9-2.9-.3-4.1-.6-.6-1.4-.9-2.1-1-.7 0-1.4.2-1.9.7L9 10.5V6.7zM15.4 16.6l-5.8 5.8c-1 1-2.4 1.5-3.9 1.4-1.5-.1-2.8-.7-3.9-1.8-2.2-2.2-2.4-5.8-.4-7.8L5.6 10v3.9l-2.2 2.3c-1 1-.9 2.9.3 4 .6.6 1.4.9 2.1 1 .7 0 1.4-.2 1.9-.7l2.8-2.8 5-5", style: this.props.st0 })
        );
    }
});

/* eslint-enable */
module.exports = exports["default"];



// WEBPACK FOOTER //
// ./~/cap-it-ui.toggles/~/cap-it-ui.icons/lib/linkBroken.js